import { Box, Grid } from '@material-ui/core'
import React from 'react'
import CustomButton from '../../components/CustomButton'
import { ROUTES } from '../../shared/constants'
import Layout from '../../components/Layout'
import { useHistory } from 'react-router-dom'
import { routeArray, textArray } from '../../utils/otherHelper'
export default function UploadStatus() {
  const history = useHistory()

  const tempModules = textArray.map((val, index) => {
    return { text: val, route: routeArray[index] }
  })

  return (
    <Layout heading="Upload Status">
      <Grid container>
        {tempModules.map((val) => (
          <Grid item lg={2} style={{ marginTop: '30px', marginLeft: '40px' }}>
            <CustomButton text={val.text} handleSubmit={() => history.push(ROUTES[val.route])} />
          </Grid>
        ))}
      </Grid>
      <Box display="flex" marginTop="30px"></Box>
    </Layout>
  )
}
